import { createFileRoute } from "@tanstack/react-router";

import { CurrentAssets } from "~/components/feature/balance/components";

export const Route = createFileRoute("/_app/dashboard/balance/current-assets/")(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <CurrentAssets />;
}
